// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3lo-f","gfeWrapper":"CalendarEvent_gfeWrapper__GBmlj"};